<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_11"></a><strong><span class="small">NATIVE PLANTS<br/>FOR SOUTHWESTERN LANDSCAPES</span></strong></p>
<p class="pagebrk">
</p><p class="image1"><a id="page_12"></a><a id="lev1"></a><img alt="image" src="html/images/f0011-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292747364_08_hlf1.vue?f8071bba